import { EMenuActionsTypes } from '@enums/common';

export const getMenuActionWithCount = ({ all, filtered, current, selected }: any) => [
	{
		text: 'Selected on current page',
		id: EMenuActionsTypes.selected,
		disabled: false,
		count: selected,
	},
	{
		text: 'Current page',
		id: EMenuActionsTypes.currentPage,
		disabled: false,
		count: current,
	},
	{
		text: 'All filtered',
		id: EMenuActionsTypes.allFiltered,
		disabled: false,
		count: filtered,
	},
	{
		text: 'All',
		id: EMenuActionsTypes.all,
		disabled: false,
		count: all,
	},
];
